module.exports = require("./tr-CY.d.ts");